import { BTResource, ExternalAction } from './SidekickModuleSpec';

export default class SidekickThread {
  id: string;
  name: string;
  enabled: boolean;
  custom: boolean;
  stepData: StepData[];
  stagingStepData: StepData[];
  reason: string;
  next: string | boolean;
  nextData: NextData[];
  updatedAt?: Date;
  updatedAtString?: string;
}

export class SidekickThreadFast {
  custom: boolean;
  enabled: boolean;
  hasActions: boolean;
  id: string;
  name: string;
  next: boolean;
  updatedAt?: Date;
  updatedAtString?: string; // TODO: calculated field
}

export class NextData {
  id?: string; // This is generated in the code
  controlValues: Object;
  integrations: Object;
  modifierValues: ModifierValue[];
  name: string;
  externalAction?: ExternalAction | null;
  btResource?: BTResource | null;
}

export class ModifierValue {
  id?: string; // This is generated in the code
  controlValues: Record<string, any> | any;
  integrations: Object;
  name: string;
}

export class StepData {
  id: number;
  comment?: string;
  parentID: number | null;
  type: string;
  outMems?: string[];
  content?: string;
  priority?: number;
}

export type SidekickThreads = SidekickThread[];
